import { cn } from "@/lib/utils";
import { brandLogoSourceSet } from "@/lib/public-branding";

type BrandLogoProps = {
  className?: string;
  eager?: boolean;
  src?: string;
  displayWidth?: number;
  sizes?: string;
  intrinsicWidth?: number;
  intrinsicHeight?: number;
};

export default function BrandLogo({
  className,
  eager = false,
  src = "/brand/enkey-logo.png",
  displayWidth,
  sizes,
  intrinsicWidth = 1000,
  intrinsicHeight = 1000,
}: BrandLogoProps) {
  const sourceSet = brandLogoSourceSet(src, intrinsicWidth);
  const image = (
    <img
      src={src}
      alt="Enkey Agency"
      width={intrinsicWidth}
      height={intrinsicHeight}
      loading={eager ? "eager" : "lazy"}
      fetchPriority={eager ? "high" : "auto"}
      decoding="async"
      className={cn("object-contain", className)}
      style={
        displayWidth
          ? {
              width: `${displayWidth}px`,
              maxWidth: "100%",
            }
          : undefined
      }
    />
  );

  if (!sourceSet) return image;

  return (
    <picture>
      <source
        type="image/webp"
        srcSet={sourceSet}
        sizes={
          sizes ??
          (displayWidth
            ? `(max-width: ${displayWidth}px) 100vw, ${displayWidth}px`
            : "(max-width: 640px) 160px, 240px")
        }
      />
      {image}
    </picture>
  );
}
